import React, { ReactNode } from 'react';

interface CollapseContentProps {
  children: ReactNode;
  className?: string;
}
const CollapseContent: React.FC<CollapseContentProps> = ({
  children,
  className = '',
}) => {
  return (
    <div
      className={`columns-1 md:columns-2 gap-2 md:gap-4 space-y-2 md:space-y-4 ${className}`}
    >
      {React.Children.map(children, (child, index) => (
        <div key={index} className="break-inside-avoid mb-2 md:mb-4">
          {child}
        </div>
      ))}
    </div>
  );
};

export default CollapseContent;
